// ReactJs
import React, { useState } from 'react'
import { useNavigate } from 'react-router'
// Node modules
import styled from 'styled-components'
// Utils
import { isCreated } from '@shared/utils/record'
// Services
import { deleteRecord } from '../../../services/record-services'
// Styles
import Popup from '../../../components/Popup'
import Actions from '../../../components/Actions'
// Layouts
import WelcomePageTitle from './WelcomePageTitle'
import WelcomePageRecord from './WelcomePageRecord'


const WelcomePageOtherRecordsContainer = styled.div`
`

const PopupContainer = styled.div`
  padding: 16px 20px;
  display: flex;
  flex-direction: column;

  & >.title {
    text-align: center;
    margin-bottom: 10px;
  }

  & >.actions {
    flex-direction: row-reverse;
    justify-content: space-evenly;
    margin-bottom: 0;

    & >.clear {
      margin-top: 0;
    }
  }
`

export default function WelcomePageOtherRecords({ records, babysittingModes, isChildActive }) {

  const navigate = useNavigate()

  const [isOpen, setIsOpen] = useState(false)
  const [recordToDelete, setRecordToDelete] = useState(null)

  const openRecord = (record) => {
    if (isCreated(record)) {
      navigate(`/record/${ record._id }`)
    }
    return true
  }

  const selectRecordToDelete = (record) => {
    setRecordToDelete(record)
    setIsOpen(true)
    return true
  }

  const cancel = () => {
    setIsOpen(false)
    return true
  }

  const remove = async (record) => {
    const indexOfRecordToDelete = records.indexOf(record)
    const result = await deleteRecord(record._id)
    result && records.splice(indexOfRecordToDelete, 1)
    setIsOpen(false)
    setRecordToDelete(null)
  }

  return (
    <WelcomePageOtherRecordsContainer>

      { records && records.length > 0 && <WelcomePageTitle margin="40px 0px 15px 20px" label="Mes dossiers"/> }

      { records.map((record) => {

        const actionRecord = isCreated(record) ? () => openRecord(record) : null
        const additionalActionRecord = isCreated(record) ? () => selectRecordToDelete(record) : null
        return (
          <WelcomePageRecord
            key={ record._id }
            record={ record }
            babysittingModes={ babysittingModes }
            isChildActive={ isChildActive }
            actionRecord={ actionRecord }
            additionalActionLabel={ 'Supprimer ma demande' }
            additionalActionRecord={ additionalActionRecord }/>
        )
      }) }

      <Popup isOpen={ isOpen } onClose={ cancel }>
        <PopupContainer>
          <div className='title'>Êtes-vous sûr de supprimer ce dossier ?</div>
          <Actions
            submitTxt="Supprimer"
            submitIcon="trash"
            onSubmit={ () => {
              remove(recordToDelete)
            } }
            onCancel={ cancel }
          />
        </PopupContainer>
      </Popup>

    </WelcomePageOtherRecordsContainer>
  )

}
